import { createLogger } from "@/src/lib/logging/logger";

export const commsLogger = (fileName: string, meta?: Record<string, any>) => {
  const logger = createLogger({
    ...meta,
    fileName,
    product: "Comms",
  });

  return {
    ...logger,
    logAndThrow(message: string, meta?: Record<string, any>, logAsError: boolean = true): never {
      return logger.logAndThrow(message, { ...meta, product: "Comms", fileName }, logAsError);
    },
  };
};

export function logAndThrow(message: string, meta?: Record<string, any>): never {
  const commsLogger = createLogger({ product: "Comms" });

  return commsLogger.logAndThrow(message, meta, true);
}
